import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };


// @Path("/api/locations")

// @POST
// {
//    "id": 1,
//    "externalId": "1000"
// }
const switchLocation = (data, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/locations/switch',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );
};

const LocationsApi = {
  switchLocation,
};

export default LocationsApi;



// WEBPACK FOOTER //
// ./src/apis/locations.js